// extracted by mini-css-extract-plugin
export default {"productCardPosition":"shopStyles_productCardPosition__N-KQ3","productCardAlignement":"shopStyles_productCardAlignement__dKkDk"};